import { handleErrorMessage } from '../../../../utils/handleErrorMessage';
import { ToastNotification } from '../../../../utils/ToastNotification';
import { CreateBudgetInput } from '../CreateBudgetForm/interfaces';
import { EditBudgetInput } from './interfaces';
import {
  createBudgetDraft,
  transformBudgetDraft,
  updateBudgetDraft,
} from './model';

export const createBudgetDraftController = async (
  budgetData: CreateBudgetInput,
) => {
  try {
    const { data } = await createBudgetDraft(budgetData);
    return data;
  } catch (err) {
    ToastNotification.show(handleErrorMessage(err), 'error');
  }
};
export const updateBudgetDraftController = async (
  budgetData: EditBudgetInput,
) => {
  try {
    const { data } = await updateBudgetDraft(budgetData);
    return data;
  } catch (err) {
    console.log(err);
    ToastNotification.show(handleErrorMessage(err), 'error');
  }
};
export const transformBudgetDraftController = async (budgetDraftId: string) => {
  try {
    const { data } = await transformBudgetDraft(budgetDraftId);
    return data;
  } catch (err) {
    ToastNotification.show(handleErrorMessage(err), 'error');
    throw err;
  }
};
